export const compareNumbers = (
  firstNumber: string,
  secondNumber: string
): number => {
  const partsA = firstNumber.split(".").map(Number);
  const partsB = secondNumber.split(".").map(Number);

  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    const a = partsA[i] || 0;
    const b = partsB[i] || 0;
    if (a < b) return -1;
    if (a > b) return 1;
  }
  return 0;
};
